import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { X } from "lucide-react";

const Modal = ({
    isOpen,
    setIsOpen,
    title,
    children,
    onSave,
    saveDisabled = false,
    saveText = "Salvar",
    cancelText = "Cancelar",
    infoContent = null,
    hideFooter = false,
    maxWidth = "max-w-md",
}) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-90"
                onClose={() => { }}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/40" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel
                                className={`w-full ${maxWidth} rounded-2xl bg-white shadow-xl`}
                            >
                                <div className="flex items-center justify-between px-6 py-4 border-b">
                                    <div className="flex items-center gap-2">
                                        <Dialog.Title className="text-lg font-semibold">
                                            {title}
                                        </Dialog.Title>
                                        {infoContent && <div>{infoContent}</div>}
                                    </div>

                                    <button
                                        onClick={() => setIsOpen(false)}
                                        className="rounded-full p-1 text-gray-400 hover:bg-gray-100"
                                    >
                                        <X size={18} />
                                    </button>
                                </div>


                                <div className="px-6 py-4">
                                    {children}
                                </div>


                                {!hideFooter && (
                                    <div className="px-6 py-4 border-t flex justify-end gap-3">
                                        <button
                                            onClick={() => setIsOpen(false)}
                                            className="px-4 py-2 rounded-xl border hover:bg-gray-50 transition"
                                        >
                                            {cancelText}
                                        </button>

                                        <button
                                            onClick={onSave}
                                            disabled={saveDisabled}
                                            className={`px-4 py-2 rounded-xl text-white transition ${saveDisabled
                                                ? "bg-gray-400 cursor-not-allowed"
                                                : "bg-custom_green hover:opacity-90"
                                                }`}
                                        >
                                            {saveText}
                                        </button>
                                    </div>
                                )}
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default Modal;
